module.exports = __webpack_public_path__ + "img/lagerausbildung_zzz.8218b411.jpg";